import { Menu, Transition } from "@headlessui/react";
import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import CatalogueName from "../../../assests/tenant/images/CatalogueName.png";
import CatalogueType from "../../../assests/tenant/images/CatalogueType.png";
import TotalGifts from "../../../assests/tenant/images/TotalGifts.png";
import UserTypes from "../../../assests/tenant/images/UserTypes.png";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useAddNewGiftsToCatalogueMutation,
  useFetchCatalogueByIdMutation,
  useUpdateStatusOfGiftInCatalogueByIdMutation,
} from "../../../features/tenant/giftCatalogue/giftCatalogueApi";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import ImageModal from "../../../components/Tenant/ImageModal/ImageModal";
import toast from "react-hot-toast";
import { useFetchAllGiftsMutation } from "../../../features/tenant/gift/giftApi";
import { HiOutlinePlus } from "react-icons/hi";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";

const GiftCatalogue = () => {
  const [showImageModal, setShowImageModal] = useState(false);


  const [showAddNewGiftsModal, setShowAddNewGiftsModal] = useState(false);

  const [selectedGifts, setselectedGifts] = useState([]);
  const [globalChecked, setGlobalChecked] = useState(false);

  const [
    updateGiftStatusInCatalogue,
    { data: updateGiftStatusInCatalogueData, error: updateGiftStatusInCatalogueError, isLoading: updateGiftStatusInCatalogueIsLoading }
  ] = useUpdateStatusOfGiftInCatalogueByIdMutation();


  const columns = [
    {
      name: "SNo",
      cell: (row, idx) => idx + 1,
      sortable: true,
      width: "80px",
    },
    {
      name: "Brand",
      cell: (row) => row.brand,
      sortable: true,
    },
    {
      name: "Gift Name",
      cell: (row) => row.name,
      sortable: true,
    },
    {
      name: "Points",
      cell: (row) => row.points,
      sortable: true,
    },
    {
      name: "Value",
      cell: (row) => row.value,
      sortable: true,
    },
    {
      name: "Image",
      cell: (row) =>
        row.images.length > 0 && (
          <div className="w-12 h-12 my-2 rounded-full">
            <img
              // style={{ width: "40px", padding: "10px" }}
              src={row.images[0]}
              alt="gift-images"
              className="rounded-full"
              onClick={() =>
                setShowImageModal(
                  row.images[0],
                )
              }
            />
          </div>
        ),
      maxWidth: "120px",
    },
    {
      name: "Gift Status",
      cell: (r) =>
        r.gift_status === "2" ? (
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={() => handleUpdate(r)}
          >
            In-Active
          </button>
        ) : (
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={() => handleUpdate(r)}
          >
            Active
          </button>
        ),
      ignoreRowClick: true,
      button: true,
    },
    {
      name: "Created By",
      cell: (row) => row.created_by_name,
      sortable: true,
    },
    {
      name: "Created At",
      cell: (row) => new Date(row.created_at).toLocaleString(),
      sortable: true,
    },
  ];

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [catalogueId, setCatalogueId] = useState(null);
  const location = useLocation();
  const [
    fetchCatalogueById,
    {
      data: catalogueData,
      isLoading: catalogueIsLoading,
      isError: cataloguesIsError,
      error: cataloguesError,
    },
  ] = useFetchCatalogueByIdMutation();

  useEffect(() => {
    console.log(location.state);
    const Id = location.state.catalogue_id;
    // console.log("objecttttt", Id);
    setCatalogueId(Id);
    fetchCatalogueById({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      id: location.state.catalogue_id,
    });
  }, [location.pathname]);

  useEffect(() => {
    if (catalogueData) {
      // console.log("catalogue data ", catalogueData.body);
      setData(catalogueData.body);
    }

    if (cataloguesError) {
      console.log("catalogue error ", cataloguesError);
    }

    // if (qrListDataIsLoading) {
    //   setLoading(qrListDataIsLoading);
    // }
  }, [catalogueData, catalogueIsLoading, cataloguesError]);

  const getUserTypeNames = (user_type_id) => {
    const userTypes = JSON.parse(sessionStorage.getItem("appUserType"));
    // console.log("object", user_type_id);

    let name = "";

    userTypes.forEach((each) => {
      if (each.user_type_id == user_type_id) {
        name = each.name;
      }
    });

    return name;
  };


  const handleUpdate = (data) => {

    let status = "1";
    if (data.gift_status == "1") {
      status = "2";
    } else status = "1";

    // console.log(data, status);

    updateGiftStatusInCatalogue({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      id: data.gc_id,
      status: status,
    });
  };



  useEffect(() => {
    toast.dismiss();
    if (updateGiftStatusInCatalogueData) {
      toast.success("Gift Status Updated Successfully.");
      fetchCatalogueById({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        id: location.state.catalogue_id,
      });
    }

    if (updateGiftStatusInCatalogueError) {
      toast.error("Please try again later.");

    }
  }, [updateGiftStatusInCatalogueData, updateGiftStatusInCatalogueError, updateGiftStatusInCatalogueIsLoading]);


  const [
    addNewGiftsToCatalogue,
    {
      data: addNewGiftsToCatalogueData,
      isLoading: addNewGiftsToCatalogueIsLoading,
      error: addNewGiftsToCatalogueError,
    },
  ] =
    useAddNewGiftsToCatalogueMutation()

  const handleAddNewGiftsCatalogue = (e) => {
    toast.dismiss();
    e.preventDefault();

    setShowAddNewGiftsModal(false);

    const giftIds = [];
    for (let i = 0; i < selectedGifts.length; i++) {
      if (selectedGifts[i].checked === true) {
        giftIds.push(selectedGifts[i].id);
      }
    }
    if (giftIds.length <= 0) {
      toast.error("Please select some gifts", {
        id: "catalogueGiftError",
      });
      return;
    }


    addNewGiftsToCatalogue({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        catalogue_name: location.state?.catalogue_name,
        catalogue_id: location.state?.catalogue_id,
        gift_id: giftIds,
      },
    });
  };

  useEffect(() => {

    if (addNewGiftsToCatalogueData) {
      toast.success("Catalogue Updated", { id: "updatedCatalogueSuccess" })
      // console.log("addNewGiftsToCatalogueData", addNewGiftsToCatalogueData);
      fetchCatalogueById({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        id: location.state.catalogue_id,
      });
    }

    if (addNewGiftsToCatalogueError) {
      toast.error("Something went wrong.", { id: "updatedCatalogueError" })
      console.log("addNewGiftsToCatalogueError", addNewGiftsToCatalogueError);
    }


  }, [addNewGiftsToCatalogueData, addNewGiftsToCatalogueError])


  const [
    fetchGifts,
    {
      data: giftsData,
      isLoading: giftsIsLoading,
      isError: giftsIsError,
      error: giftsError,
    },
  ] = useFetchAllGiftsMutation();

  useEffect(() => {
    fetchGifts({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      limit: 1000,
      offset: 0,

    });
  }, [])

  useEffect(() => {

    if (catalogueData && giftsData && catalogueData?.body && giftsData?.body?.gifts) {

      const newArr = giftsData?.body?.gifts.map((each) => ({
        ...each,
        checked: false,
      }));

      const newGifts = findNewGifts(catalogueData.body, newArr);
      // console.log("newGifts", newGifts);
      setselectedGifts(newGifts);

    }
  }, [giftsData, catalogueData]);


  function findNewGifts(giftCatalogue, gifts) {
    const existingGiftIds = new Set(giftCatalogue.map(gift => gift.id)); // Collect existing gift IDs
    return gifts.filter(gift => !existingGiftIds.has(gift.id)); // Filter out gifts that are not in giftCatalogue
  }



  const handleGlobalSelection = (e) => {
    if (globalChecked) {
      const newData = [...selectedGifts];
      for (let i = 0; i < newData.length; i++) {
        newData[i].checked = false;
      }
      setselectedGifts(newData);
      setGlobalChecked(false);
    } else {
      const newData = [...selectedGifts];
      for (let i = 0; i < newData.length; i++) {
        newData[i].checked = true;
      }
      setselectedGifts(newData);
      setGlobalChecked(true);
    }
  };



  const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme")).theme
    .color_shades;

  const handleOnChange = (e, idx) => {
    const newData = [...selectedGifts];
    newData[idx].checked = !selectedGifts[idx].checked;
    setselectedGifts(newData);
    setGlobalChecked(false);
  };




  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Gift Catalogues
            <LinksComponent />
          </div>

          <div className="p-3">
            <div className="grid grid-cols-4 gap-2 mb-2">
              <div className="w-full box_gct bg_g1">
                <div className="circle_gft">
                  <img src={CatalogueName} className="max-h-full max-w-full " />
                </div>
                <span className="text-gray-400 text-xs  block">Catalogue Name</span>
                <span className="flex text-black text-sm  gap-1 ">
                  {" "}{location.state?.catalogue_name}
                </span>
              </div>

              <div className="w-full box_gct bg_g2">
                <div className="circle_gft">
                  <img src={CatalogueType} className="max-h-full max-w-full " />
                </div>
                <span className="text-gray-400 text-xs  block"> Catalogue Type</span>
                <span className="flex text-black text-sm  gap-1"> {" "}{location.state?.catalogue_type}</span>
              </div>

              <div className="w-full box_gct bg_g3">
                <div className="circle_gft">
                  <img src={TotalGifts} className="max-h-full max-w-full " />
                </div>
                <span className="text-gray-400 text-xs  block"> Total Gifts</span>
                <span className="flex text-black text-sm  gap-1">{" "}
                  {location.state?.gift_count}{" "}</span>
              </div>

              <div className="w-full box_gct bg_g4">
                <div className="circle_gft">
                  <img src={UserTypes} className="max-h-full max-w-full " />
                </div>
                <span className="text-gray-400 text-xs  block">User Types</span>
                <span className="flex text-black text-sm  gap-1 ">
                  {data.length > 0 &&
                    data[0].user_types.map((id) => (
                      <span> {getUserTypeNames(id)} </span>
                    ))
                  }
                </span>

              </div>
            </div>
            <div className=" bg-white shadow rounded-lg">


              <div className="w-full p-3 ">
                <div className="">
                  <DataTableComponent
                    keyField={(row) => row.SNo}
                    columns={columns}
                    title={data.length > 0 && data[0].catalogue_name}
                    data={data}
                  >

                  </DataTableComponent>
                </div>
              </div>
            </div>
          </div>

          {
            location.state?.status == "1" &&
            <div
              className="fixed bottom-0 right-16 w-16 h-16 mr-10 mb-2 cursor-pointer"
              id="box_btn"
            >
              <div className="text-right">
                <Menu className="relative inline-block text-left">
                  <div>
                    <Menu.Button
                      onClick={() => setShowAddNewGiftsModal(true)}
                      className="inline-flex justify-cente w-12 h-12 rounded-full text-sm font-medium text-white hover:bg-opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 "
                      style={{ backgroundColor: `${primaryColor["700"]}` }}
                    >
                      <HiOutlinePlus className="w-full h-full p-3" />
                    </Menu.Button>
                  </div>

                </Menu>
              </div>
            </div>
          }

          {showAddNewGiftsModal && (
            <ModalComponent
              size="7xl"
              show={showAddNewGiftsModal ? true : false}
              setShow={setShowAddNewGiftsModal}
              data={showAddNewGiftsModal}
              className="overflow-y-scroll"
            >
              <div className="p-3 aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg  xl:aspect-h-8 xl:aspect-w-7">
                <h1 className="text-xl pb-2 text-center capitalize font-semibold">
                  Select New Gifts to add
                </h1>
                <div className="w-full flex justify-center ">
                  <div className="flex flex-col items-center w-full rounded-lg bg-gray-50">
                    <>
                      <tr className=" flex justify-evenly w-full bg-gray-200 ">
                        <td className="py-3 ml-2 w-8">
                          <div className="flex items-center">
                            <input
                              id="checkbox-table-search-1"
                              type="checkbox"
                              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 "
                              checked={globalChecked}
                              value={globalChecked}
                              onChange={(e) => handleGlobalSelection(e)}
                            />
                            <label
                              htmlFor="checkbox-table-search-1"
                              className="sr-only"
                            >
                              checkbox
                            </label>
                          </div>
                        </td>
                        <th
                          scope="row"
                          className="px-3 py-3 w-2/3 font-medium text-gray-900 whitespace-nowrap"
                        >
                          Name
                        </th>
                        <td className="px-2 py-3 w-1/5">Brand</td>
                        <td className="px-2 py-3 w-1/5">Points</td>
                        {/* <td className="px-2 py-3 w-1/5"></td> */}
                      </tr>
                    </>

                    {selectedGifts &&
                      selectedGifts.map((each, idx) => (
                        <>
                          <tr className="bg-white flex justify-evenly w-full hover:bg-gray-50">
                            <td className="py-3 ml-2 w-8">
                              <div className="flex items-center">
                                <input
                                  id="checkbox-table-search-1"
                                  type="checkbox"
                                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 "
                                  onChange={(e) => handleOnChange(e, idx)}
                                  value={each.checked}
                                  checked={each.checked}
                                />
                                <label
                                  htmlFor="checkbox-table-search-1"
                                  className="sr-only"
                                >
                                  checkbox
                                </label>
                              </div>
                            </td>
                            <th
                              scope="row"
                              className="px-3 py-2 w-2/3 font-medium overflow-x-scroll text-gray-900 whitespace-nowrap"
                            >
                              {each.name}
                            </th>
                            <td className="px-2 py-2 w-1/5">
                              {each.brand}
                            </td>
                            <td className="px-2 py-2 w-1/5">
                              {each.points}
                            </td>
                            {/* <td className="px-2 py-2 w-1/5">
                                  {each.checked ? "True" : "False"}{" "}
                                </td> */}
                            {/* <td className="px-2 py-2 w-1/5">{idx}</td> */}
                          </tr>
                        </>
                      ))}
                  </div>

                </div>
                <div className="mt-3 flex justify-center ">
                  <button
                    type="submit"
                    onClick={(e) => handleAddNewGiftsCatalogue(e)}
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                  >
                    Save
                  </button>
                </div>
              </div>
            </ModalComponent>
          )}


        </div>
        {showImageModal && (
          <ImageModal
            show={showImageModal ? true : false}
            setShow={setShowImageModal}
            size="md"
            data={showImageModal}
          >
            <div className="p-3 aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg  xl:aspect-h-8 xl:aspect-w-7">
              <img
                src={showImageModal}
                className="h-full w-full object-cover object-center group-hover:opacity-75"
              />
            </div>
          </ImageModal>
        )}
      </div>
    </>
  );
};

export default GiftCatalogue;
